"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../schema");
const role_1 = require("../../concepts/role");
const occupation_1 = require("../../concepts/occupation");
const language_1 = require("../../concepts/language");
const stampNumber = schema_1.Schema.stampNumber();
exports.validator = schema_1.Schema.object()
    .properties({
    title: schema_1.Schema.string().optional(),
    firstName: schema_1.Schema.string().optional(),
    lastName: schema_1.Schema.string().optional(),
    email: schema_1.Schema.email(),
    role: role_1.role,
    phoneNumber: schema_1.Schema.phoneNumber().optional(),
    occupation: occupation_1.occupation.optional(),
    stampNumber: schema_1.Schema.ifThenElse(schema_1.Schema.expression(`{../occupation} === "${occupation_1.Occupation.Doctor}"`), stampNumber.optional(), stampNumber.forbidden()),
    defaultLanguage: language_1.language.default(language_1.Locale.HU).optional()
})
    .sealed()
    .default({});
